import { DaymapQuery as l } from "../daymapQuery.js";
var c;
((a) => {
  ((e) => {
    e[e.Private = 4] = "Private", e[e.Shared = 8] = "Shared", e[e.School = 16] = "School";
  })(a.ScopeEnum || (a.ScopeEnum = {}));
  class u extends l {
    constructor(s) {
      super(
        ["coursesByClassAndYear", s.classId, s.year],
        s,
        `/lms/api/curriculum/course/coursebyclassandyear?classId=${s.classId}&year=${s.year}`,
        null,
        {
          stale: 1e3 * 60 * 60,
          enabled: s.enabled
        }
      );
    }
  }
  a.CourseByClassAndYear = u;
  class t extends l {
    constructor(s) {
      const r = s.year ? `?year=${s.year}` : "";
      super(
        ["coursePosts", s.classId, s.year],
        s,
        `/lms/api/coms/posts/class/${s.classId}${r}`,
        null,
        {
          stale: 1e3 * 60 * 60
        }
      );
    }
  }
  a.CoursePosts = t;
  class o extends l {
    constructor(s) {
      const { courseId: r, enabled: d = !0 } = s;
      super(
        ["courseWithResources", r],
        s,
        `/lms/api/curriculum/course/resources?courseId=${r}`,
        null,
        {
          stale: 1e3 * 60 * 60,
          enabled: d
        }
      );
    }
  }
  a.CourseWithResources = o;
})(c || (c = {}));
export {
  c as courses
};
//# sourceMappingURL=index.js.map
